import React from 'react';
import type { PropsWithChildren } from 'react';
import styled from 'styled-components';

import { themeDefault } from 'styles';

import { HorizontalLayout } from './Layout';
import { Text } from './Text';

export type TagTypes = keyof typeof TAG_COLORS;
interface TagProps {
    type?: TagTypes;
    icon?: JSX.Element;
    width?: string;
}

export const Tag = ({ children, type, icon, width }: PropsWithChildren<TagProps>) => (
    <TagWrapper $type={type} $width={width}>
        <HorizontalLayout $gap={4} $rowCenter>
            {icon}
            <Text $uppercase helper>
                {children}
            </Text>
        </HorizontalLayout>
    </TagWrapper>
);

const TagWrapper = styled.div<{ $type?: TagTypes; $width?: string }>`
    height: 24px;
    min-width: 90px;
    width: ${({ $width = 'fit-content' }) => $width};
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0 8px;
    border-radius: 3px;
    color: ${({ $type = 'neutral' }) => TAG_COLORS[$type].color};
    border: 1px solid ${({ $type = 'neutral' }) => `${TAG_COLORS[$type].background}`};
    background-color: ${({ $type = 'neutral' }) => `${TAG_COLORS[$type].background}80`};
    text-transform: capitalize;
    flex-shrink: 0;
`;

const TAG_COLORS = {
    neutral: {
        background: themeDefault.colors.cocoa200,
        color: themeDefault.intent.neutral,
    },
    positive: {
        background: themeDefault.colors.green100,
        color: themeDefault.intent.positive,
    },
    negative: {
        background: themeDefault.colors.red100,
        color: themeDefault.intent.negative,
    },
    info: {
        background: themeDefault.colors.seafoam200,
        color: themeDefault.intent.info,
    },
    highlight: {
        background: themeDefault.colors.gold100,
        color: themeDefault.text.primary,
    },
};
